var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHashtagSmall({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.04 18.5l.44-3.74H7v-1.88h1.7l.28-2.2H7.4V8.8h1.82l.42-3.3h1.68l-.4 3.3H13l.42-3.3h1.68l-.4 3.3h1.58v1.88h-1.82l-.26 2.2h1.68v1.88h-1.9l-.46 3.74h-1.7l.44-3.74H10.2l-.46 3.74h-1.7zm2.38-5.62h2.06l.28-2.2h-2.08l-.26 2.2z"
  })));
}

export default SvgHashtagSmall;